import isEmpty from 'lodash/isEmpty';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { userProvider } from '../../data/providers/userProvider';
import { IPermission, IUser } from '../../data/types';
import { AccessDenied } from './AccessDenied';

interface IMatchParams {
  teamId: string;
}

interface IProps extends RouteComponentProps<IMatchParams> {
  // tslint:disable-next-line:no-any
  children?: React.ReactNode;
}

const TeamWriteAccessCheckComponent: React.FunctionComponent<IProps> = (
  props: IProps
): React.ReactElement => {
  const [authChecked, setAuthChecked] = React.useState<boolean>(false);
  const [initialCheck, setInitialCheck] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect((): (() => void) => {
    const { teamId } = props.match.params;
    const subscriber = userProvider().subscribe((user: IUser): void => {
      if (isOrgAdmin(user) || hasTeamWriteAccess(user, teamId)) {
        setInitialCheck(true);
        setAuthChecked(true);
      }

      if (!isEmpty(user)) {
        setLoading(false);
      }
    });
    return (): void => {
      subscriber.unsubscribe();
    };
  }, [props.match.params.teamId]);

  return authChecked ? (
    <React.Fragment>{props.children}</React.Fragment>
  ) : !initialCheck && loading ? null : (
    <AccessDenied />
  );
};

const TeamWriteAccessCheck = withRouter(TeamWriteAccessCheckComponent);

export { TeamWriteAccessCheck };

const isOrgAdmin = (user: IUser): boolean => {
  return (
    !isEmpty(user) && !isEmpty(user.claims) && user.claims.orgAdmin === true
  );
};

const hasTeamWriteAccess = (user: IUser, teamId: string): boolean => {
  if (!isEmpty(user) && !isEmpty(user.permissions)) {
    const team = user.permissions.find(
      (p: IPermission): boolean => p.id === teamId && p.write === true
    );
    return !!team;
  }
  return false;
};
